import React from "react";
import { ArrowDown, ArrowUp } from "../icons";
import AccordionTitle from "./AccordionTitle";

const AccordionItem = ({
  children, // The content inside the accordion item (title + body)
  isOpen, // Boolean to control if this item is currently expanded
  onToggle, // Function to toggle this item's open/closed state
  size = "md", // Size variant of the accordion item (e.g., sm, md, lg)
}) => {
  /* === Separate Title and Content === */
  let titleContent = null;
  const contentChildren = [];

  React.Children.forEach(children, (child) => {
    if (child?.type === AccordionTitle) {
      titleContent = child; // Extract AccordionTitle
    } else {
      contentChildren.push(child); // Extract rest as content
    }
  });
  /* === End Separate Title and Content === */

  return (
    <div className={`borderWrapper ${isOpen ? "open" : ""}`}>
      <div className={`accordion-item borderInner ${size}`}>
        <div className="accordion-header" onClick={onToggle}>
          <div className="accordion-title">{titleContent}</div>
          <span className="arrow">
            {isOpen ? <ArrowUp size={size} /> : <ArrowDown size={size} />}
          </span>
        </div>

        <div className="accordion-body">
          <div className="accordion-content">{contentChildren}</div>
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
